import {
    AfterViewInit,
    booleanAttribute,
    ChangeDetectionStrategy,
    Component,
    Input,
    ViewEncapsulation
} from '@angular/core';
import { ExpansionPanelComponent } from '../../../expansion-panel/expansion-panel.component';
import { UmbracoBlockConfiguration } from '../../models/umbraco-blocks.types';
import { SanitizeHtmlPipe } from '../../pipes/sanitize-html.pipe';
import { TintDirective } from '../tint/tint.directive';
import { ExpansionPanelItem, ExpansionPanelMedia } from './models/expansion-list.type';
import { NgOptimizedImage } from '@angular/common';

@Component({
    selector: 'nw-expansion-list-block',
    imports: [ExpansionPanelComponent, SanitizeHtmlPipe, TintDirective, NgOptimizedImage],
    templateUrl: './expansion-list-block.component.html',
    styleUrl: './expansion-list-block.component.scss',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ExpansionListBlockComponent implements AfterViewInit {
    @Input() heading?: string;
    @Input() subheading?: string;
    @Input() media?: ExpansionPanelMedia;
    @Input() callToAction?: Pick<UmbracoBlockConfiguration.Button, 'label' | 'path'>;
    @Input() items!: ExpansionPanelItem[];
    @Input({ transform: booleanAttribute }) border: boolean = false;

    private intervalId!: unknown;

    public ngAfterViewInit(): void {
        this.forceAutoplay();
    }

    private forceAutoplay(): void {
        if (this.media?.type !== 'video') return;

        const MAX_ATTEMPTS: number = 10;
        let attempts: number = 0;

        this.intervalId = setInterval(() => {
            const video: HTMLVideoElement | null = document.getElementById(
                `${this.media?.id}video`
            ) as HTMLVideoElement;

            if (!video && attempts < MAX_ATTEMPTS) {
                attempts++;
                return;
            }

            if (!video || attempts >= MAX_ATTEMPTS) {
                clearInterval(this.intervalId as number);
                return;
            }

            const promise = video.play();
            if (promise !== undefined) {
                promise
                    .then(() => {})
                    .catch(() => {
                        video.muted = true;
                        video.play();
                    });
            }
            attempts++;
        }, 1000);
    }
}
